export const CompanyThemes = {
  Id: 'Identifier',
  Active: 'Active',
  Company: 'Company',
  Metadata: 'Metadata',
  Theme: 'Theme',
  Version: 'Version',
};
